const pages = {
  about: {
    hero: {
      badge: "સ્થાપના ૨૦૦૨ • ગુજરાતનું સૌથી મોટું આશ્રયસ્થાન",
      titleStart: "એક એવું ઘર જ્યાં ",
      titleHighlight: "દરેક વડીલ",
      titleEnd: " પરિવાર છે.",
      description:
        "સ્વ. શ્રી ચંપકલાલ ઘેલાભાઈ શાહના પરોપકારથી ૨૦૦૨માં સ્થપાયેલી જીવનધારા વૃદ્ધાશ્રમ એક હૂંફભર્યું, પ્રેમભર્યું પરિવાર છે. લાંભા, અમદાવાદમાં ૧૦,૦૦૦ ચોરસ ગજના આશ્રયસ્થાનમાં માત્ર ૧૭ નિવાસી વડીલ સાથે શરૂઆત કરી, અમે આજે ગુજરાતનું સૌથી મોટું વૃદ્ધાશ્રમ છીએ, ગૌરવથી ૩૦૦થી વધુ પ્રિય વડીલની સંભાળ રાખીએ છીએ.",
      supportCause: "અમારા ઉદ્દેશને સહકાર આપો",
      visitHome: "ઘરની મુલાકાત લો",
      quote:
        "\"સેવા એ નથી જે આપણે બીજાઓ માટે કરીએ છીએ. એ તો છે જે આપણે સાથે મળીને બનીએ છીએ.\"",
      founderName: "શ્રી મનહરલાલ શાહ",
      founderRole: "સ્થાપક ટ્રસ્ટી, જીવનધારા વૃદ્ધાશ્રમ",
      poem: {
        title: "જીવનધારા એટલે શું?",
        intro: "કોઈ પૂછે કે શું છે જીવનધારા?\nતો ગર્વથી કહું કે...",
        lines: [
          "વિશ્રામ અને વિશ્વાસનું સ્થળ છે, જીવનધારા",
          "વર્ષ 2002 માં રોપાયેલું બીજ, આજે વટવૃક્ષ છે, જીવનધારા",
          "સૂકા ભઠ્ઠ રણમાં, ઝરણાની મીઠી ધાર છે, જીવનધારા",
          "ધોમધખતા બપોરે, વડલાની શીતળ છાયા છે, જીવનધારા",
          "વડીલોના સૂના સંસારમાં, આંબા ડાળે ચહેકતી કોયલ સમી છે, જીવનધારા",
          "નિરાધારનો ઓટલો અને રોટલો છે, જીવનધારા",
          "આંસુ ભરેલી આંખોની આશ, ઘડપણનું મધુર સ્મિત છે, જીવનધારા",
          "જ્યાં ઘડપણ ઝૂલે હીંચકે ને, સંગીતના તાલે સ્તવન સંભળાય,",
          "જ્યાં સંધ્યાવંદન ને આરતી રોજ ગવાય, એવી મધુર ધૂન છે, જીવનધારા",
          "લાગણીઓ ના ધોધ વહે, જ્યાં હૂંફનો વરસાદ,",
          "પહેલા વરસાદની ભીની માટી સમી સુગંધ છે, જીવનધારા",
          "આદ્ય સ્થાપક સ્વ. શ્રી ચંપકલાલ શાહની આંખોના તારલા,",
          "પ્રભુના દુલારા, કરુણામૂર્તિ અને સાચા જનસેવક",
          "શ્રી સંદીપભાઈ શાહનું સપનું છે, જીવનધારા 🙏",
          "ગુજરાત નુ ગૌરવ છે, જીવનધારા, ગુજરાત નુ ગૌરવ છે જીવનધારા 🚩",
          "માં ની નજર, બાપની હૂંફ...!",
          "એ જ તો છે, આપણી જીવનધારા! ✨",
          "આથી વિશેષ શુ કહુ? શુ છે જીવનધારા...વડીલો નુ વાત્સલ્ય ધામ છે જીવનધારા! 💜"
        ],
        authorLabel: "લેખક/ Writer",
        authorName: "Dhruti Dwivedi",
        foundation: "જીવનધારા વૃદ્ધાશ્રમ પરિવાર",
        readMore: "વધુ વાંચો",
        close: "બંધ કરો"
      },
    },
    stats: {
      residents: "આજીવન સંભાળમાં વડીલ",
      donors: "અમને સહકાર આપતા દાતા પરિવારો",
      years: "વિશ્વસનીય સેવા",
      tax: "12A અને 80G કર સુસંગત",
    },
    initiatives: {
      eyebrow: "અમારી મુખ્ય પહેલો",
      heading: "કાળજી, કરુણા અને ઉદ્દેશ સાથે સેવા",
      description:
        "જીવનધારા વૃદ્ધાશ્રમ વરિષ્ઠ નાગરિકો અને વ્યાપક સમુદાયના આરોગ્ય, ગૌરવ, પોષણ અને કલ્યાણ માટે જે મુખ્ય પહેલો દ્વારા સહારો આપે છે તે જાણો.",
      slides: {
        elderCare: {
          label: "આજીવન સંભાળ",
          title: "રહેણાંક વૃદ્ધ સંભાળ",
          body: "દરેક વડીલને આજીવન કાળજી, સાથીપણું અને વ્યક્તિગત ધ્યાન આપતું સુરક્ષિત અને કરુણાભર્યું ઘર.",
          cta: "વૃદ્ધ સંભાળ જુઓ",
        },
        healthcare: {
          label: "તબીબી સેવા",
          title: "આરોગ્ય અને પુનર્વસન",
          body: "કેમ્પસમાં ક્લિનિક, ડૉક્ટર સહારો, દવા સહાય અને કેમ્પ્સ — અમારા વડીલને રોજ સુરક્ષિત રાખે છે.",
          cta: "આરોગ્ય સેવા જુઓ",
        },
        gaushala: {
          label: "ગૌસેવા",
          title: "વૃંદાવન ગીર ગૌશાળા",
          body: "પોષક દૂધ અને સમર્પિત ગૌસેવા જે અમારા વડીલને પોષે છે અને પવિત્ર પરંપરાનું સન્માન કરે છે.",
          cta: "ગૌશાળા જુઓ",
        },
        donate: {
          label: "દાન",
          title: "અમારા કારણોને સહારો આપો",
          body: "ભોજન, તબીબી સંભાળ અથવા વડીલને પ્રાયોજિત કરો — દરેક યોગદાન હૂંફ અને ગૌરવ બને છે.",
          cta: "હમણાં દાન કરો",
        },
        tiffin: {
          label: "અન્નદાન",
          title: "ટિફિન સેવા",
          body: "કાળજીથી પહોંચાડાતા પોષક ભોજન — જીવનધારા વૃદ્ધાશ્રમની સેવાને કેમ્પસથી આગળ લઈ જાય છે.",
          cta: "ટિફિન સેવા જુઓ",
        },
        gallery: {
          label: "પળો",
          title: "જીવનધારા વૃદ્ધાશ્રમની અંદરનું જીવન",
          body: "તહેવારો, સંભાળની સવારો અને સહિયારો આનંદ — અમે રોજ બનાવતા પરિવારની ઝાંખીઓ.",
          cta: "ગૅલરી જુઓ",
        },
      },
    },
    story: {
      eyebrow: "અમારી ઉમદા",
      heading:
        "૨૦૦૨માં એક પિતાની ઉમદા દયાળતાએ ગુજરાતનું સૌથી મોટું વરિષ્ઠ આશ્રયસ્થાન રચ્યું.",
      chronicled: "અઢી દાયકાઓ દરમિયાન નોંધાયેલું",
      dropcap: "જી",
      p1a: "વનધારા વૃદ્ધાશ્રમ અમારા હૃદયમાં એક વિશેષ સ્થાન ધરાવે છે, કારણ કે તે અમારા જીવનમાં મારા સ્વર્ગીય પિતા શ્રી ચંપકલાલ ઘેલાભાઈ શાહની દયાળતાથી પ્રવેશ્યું. તેમણે અમદાવાદના દક્ષિણ વિસ્તારમાં નારોલ ઔદ્યોગિક વિસ્તરણ વિસ્તારની સામે આવેલી લાંભામાં ૧૦,૦૦૦ ચોરસ ગજ જમીન દાન કરીને અદ્ભુત યોગદાન આપ્યું. તેમણે આ ઘરની સ્થાપના ",
      p1bold: "૨૦૦૨",
      p1b: "માં કરી, માત્ર પાંચ ઓરડા, ભોજનાલય, સુંદર બગીચા અને શાંત મંદિરથી શરૂઆત કરી.",
      p2: "અમે તેમના માર્ગદર્શનનું નિષ્ઠાપૂર્વક પાલન કરીને જીવનધારા વૃદ્ધાશ્રમને હૂંફભર્યું, પ્રેમભર્યું અને સહાયક પરિવાર બનાવ્યું. અમારા ઉત્કૃષ્ટ ટ્રસ્ટીઓ, ઉદાર દાતાઓ અને સમર્પિત કર્મચારીઓના સહયોગથી અમે તેમના સ્વપ્નને સાકાર કર્યું, હૃદય, કરુણા અને આદરથી ભરેલું આશ્રયસ્થાન બનાવ્યું. અમારી યાત્રાને યાદ કરવું અદ્ભુત છે; માત્ર ૧૭ વડીલ સાથે શરૂઆત કરીને, અમે આજે ગુજરાતનું સૌથી મોટું વૃદ્ધાશ્રમ હોવાનું ગૌરવ અનુભવીએ છીએ, જેમાં ૩૬૦ વરિષ્ઠ નાગરિકો માટે જગ્યા છે.",
      p3: "જેમ જેમ અમારો જીવનધારા વૃદ્ધાશ્રમ પરિવાર વિકસતો ગયો, અમે અમારા વડીલની વિકસતી શારીરિક, ભાવનાત્મક અને આધ્યાત્મિક જરૂરિયાતો પૂરી કરવા માટે ઊંડી પ્રતિબદ્ધતા જાળવી રાખી. ડિસેમ્બર ૨૦૧૨માં, અમે ૨૨ ઓરડા સાથે સંકુલ ૧ શરૂ કર્યું, જેમાં અમારા વડીલની આરામ માટે વધારાની સુવિધાઓ પણ હતી. પછી, ૨૦૧૫માં, અમે ૨૮ ઓરડા ધરાવતું સંકુલ ૨ ગૌરવથી સ્વાગત કર્યું, અને ૨૧ મે, ૨૦૨૨ના રોજ, અમે અમારા વધતા પરિવારને સમાવવા માટે સંકુલ ૩ (સેવા સદન, શાંતિ સદન અને પ્રેમ ભવન) નું ઉદ્ઘાટન ઉજવ્યું.",
      p4: "જીવનધારા વૃદ્ધાશ્રમમાં, અમે ખુશહાલ, ગૌરવશાળી અને સંતોષકારક વાતાવરણ પૂરું પાડવાનો લક્ષ્ય રાખીએ છીએ. દરેક વૃદ્ધ વ્યક્તિને અહીં પ્રિય માનવામાં આવે છે અને મોટો આનંદ મળે છે, જે હૃદયસ્પર્શી અને આનંદભર્યું વાતાવરણ ઊભું કરે છે. અમારા સમુદાયનો ભાગ બનવાથી, તમે અમારી સહકારિત યાત્રાને સમૃદ્ધ બનાવી શકો છો અને અમારા વડીલના ગૌરવ અને સુખમાં યોગદાન આપી શકો છો.",
    },
    milestones: {
      eyebrow: "સીમાચિહ્નો",
      heading: "પા સદી, એક સમયે એક વડીલ",
      m2002: {
        title: "એક નમ્ર શરૂઆત",
        body: "લાંભામાં દાનમાં મળેલી ૧૦,૦૦૦ ચોરસ ગજ જમીન પર ૧૭ વડીલો સાથે પાંચ ઓરડા, ભોજનાલય, સુંદર બગીચો અને શાંત મંદિરથી શરૂઆત.",
      },
      m2011_gruh: {
        title: "મહિલા ઉત્કર્ષ કેન્દ્ર – સદ્ગુણા ગૃહ ઉદ્યોગ",
        body: "વડીલો અને બહેનોને આત્મનિર્ભરતા, પૌષ્ટિક ખાદ્ય ઉત્પાદન દ્વારા સન્માનપૂર્વક જોડવા ગૃહઉદ્યોગની શરૂઆત.",
      },
      m2011_med: {
        title: "ભગવાન મહાવીર મેડિકલ સેન્ટર",
        body: "રોજિંદા OPD તપાસ, નિષ્ણાત ડોક્ટરોની મુલાકાત અને નિઃશુલ્ક દવાઓ સાથે ભગવાન મહાવીર મેડિકલ સેન્ટરની સ્થાપના.",
      },
      m2012: {
        title: "સંકુલ ૧ વિસ્તરણ",
        body: "અમારા વડીલોની સુરક્ષા અને આરામ વધારવા માટે ૨૨ સુસજ્જ ઓરડા અને વધારાની ઉપયોગી સુવિધાઓ ધરાવતું સંકુલ ૧ શરૂ કર્યું.",
      },
      m2014: {
        title: "ભગવાન મહાવીર સિનિયર સિટીઝન ટિફિન સેવા",
        body: "જરૂરિયાતમંદ અને એકાંકી વડીલો સુધી દરરોજ તાજું, સાત્વિક અને પૌષ્ટિક જૈન ભોજન પહોંચાડવા ટિફિન સેવાની શરૂઆત.",
      },
      m2015: {
        title: "સંકુલ ૨ નું સ્વાગત",
        body: "૨૮ પ્રીમિયમ ઓરડા ધરાવતું સંકુલ ૨ ગૌરવથી સ્વાગત કર્યું, અમારા ઝડપથી વધતા વરિષ્ઠ પરિવારને સમાવવાની ક્ષમતા વધારી.",
      },
      m2016: {
        title: "ભગવાન મહાવીર આઈ કેર હોસ્પિટલ",
        body: "વડીલો અને દર્દીઓ માટે નેત્ર નિદાન, ચશ્મા વિતરણ અને વિનામૂલ્યે મોતીયાના ઓપરેશન સાથે નેત્ર વિભાગ શરૂ કર્યો.",
      },
      m2017: {
        title: "વૃંદાવન ગીર ગૌશાળા",
        body: "વૃંદાવન ગીર ગૌશાળાની સ્થાપના — વડીલો માટે શુદ્ધ ગીર ગાયનું દૂધ અને પવિત્ર ગૌસેવા પરંપરાનું જતન.",
      },
      m2018: {
        title: "ભગવાન મહાવીર ફિઝિયોથેરાપી સેન્ટર",
        body: "ગુજરાતનું પ્રથમ વૃદ્ધાશ્રમ પક્ષઘાત (પેરાલિસિસ) પુનર્વસન અને અદ્યતન ઇલેક્ટ્રોથેરાપી સાથે ફિઝિયોથેરાપી સેન્ટર.",
      },
      m2022: {
        title: "સંકુલ ૩ નું ઉદ્ઘાટન",
        body: "સંકુલ ૩ (સેવા સદન, શાંતિ સદન અને પ્રેમ ભવન) નું ઉદ્ઘાટન કર્યું, સંપૂર્ણ સ્વાગત ક્ષમતા ૩૬૦+ વડીલો સુધી વધારી.",
      },
      m2024_dental: {
        title: "ભગવાન મહાવીર ડેન્ટલ ક્લિનિક",
        body: "અદ્યતન ડેન્ટલ ચેર, ઓરલ હાઇજીન સારવાર અને ચોકઠાં સહાય સાથે આધુનિક દંત ચિકિત્સા યુનિટની શરૂઆત.",
      },
      m2024_beyond: {
        title: "યાત્રા અવિરત ચાલુ છે",
        body: "પ્રેમભરી સેવા, આધુનિક સ્વાસ્થ્ય સુવિધાઓ અને વડીલોના ગૌરવપૂર્ણ આજીવન આશ્રયના પવિત્ર યજ્ઞને આગળ ધપાવતાં.",
      },
      upcoming: {
        eyebrow: "આગળની યાત્રા",
        heading: "આગામી પ્રોજેક્ટ્સ",
        years: "૨૦૨૭–૨૦૨૮",
        tag: "આગામી",
        vatsalyadham: {
          title: "જીવનધારા વાત્સલ્યધામ",
          body: "૨,૫૦૦ વડીલો રહી શકે તેવું વિશાળ વૃદ્ધાશ્રમ.",        },
        hospital: {
          title: "ઉષા જીત ભગવાન મહાવીર હોસ્પિટલ",
        },
        cancerCare: {
          title: "ભગવાન મહાવીર કરુણાલય – કેન્સર કેર સેન્ટર",
        },
        paralysisRehab: {
          title: "પેરાલિસિસ રિહેબિલિટેશન સેન્ટર",
        },
      },
    },
    mvv: {
      mission: {
        tag: "ધ્યેય",
        title: "અડગ સહાય અને સંભાળ",
        body: "અમારા વડીલ માટે એવી જ રીતે હાજર રહેવું જેવી રીતે માતા-પિતા દરેક પડકણ પછી પોતાના બાળકોને સહારો આપવા માટે હંમેશા ત્યાં હોય છે — તેમની ડગમગતી ઉમરે નિઃશરતી પ્રેમ, આશ્રય અને આરામ આપવું.",
      },
      vision: {
        tag: "દૃષ્ટિ",
        title: "એકાંતી માટે સંગાથી",
        body: "જેમણે ક્યારેય લગ્ન ન કર્યા, સંતાન વિનાના દંપતીઓ જેમના સુવર્ણ વર્ષો નજીક આવી રહ્યા છે, અને જેમણે પોતાના જીવનસાથી ગુમાવ્યા છે તેવા જીવંત ભાગીદારો માટે સુરક્ષિત અને હૂંફભર્યું આશ્રયસ્થાન પૂરું પાડવું, જેથી કોઈ વરિષ્ઠ નાગરિક એકલો ન રહે.",
      },
      values: {
        tag: "મૂલ્યો",
        title: "ગૌરવ, શાંતિ અને આનંદ",
        body: "ખુશહાલ અને સંતોષકારક વાતાવરણ પૂરું પાડવું જ્યાં દરેક વડીલ સહજતા, આદર અને ઊંડા આધ્યાત્મિક સાંત્વનાથી જીવે. હૃદયસ્પર્શી અને આનંદભર્યું વાતાવરણ ઊભું કરવું.",
      },
    },
    triptych: {
      eyebrow: "ઘરની અંદર",
      heading: "જીવનધારા વૃદ્ધાશ્રમની અંદર નજીકથી જોઈએ",
      description:
        "10,000 ચોરસ ગજના વિશાળ વિસ્તારમાં ફેલાયેલ, જીવનધારા વૃદ્ધાશ્રમ અમારા 300+ વડીલના સંપૂર્ણ શારીરિક, તબીબી, ભાવનાત્મક અને આધ્યાત્મિક કલ્યાણ માટે ડિઝાઇન કરેલી વિશાળ, ઉચ્ચ-ગુણવત્તાની આધુનિક સુવિધાઓ પ્રદાન કરે છે.",
      careAlt: "આરામદાયક વાતાવરણમાં સંભાળ રાખનાર અને વડીલ",
      mealAlt: "ભોજનગૃહમાં વડીલ સહિયારું ભોજન કરે છે",
      medicalAlt: "વડીલને તબીબી સંભાળ આપતા ડૉક્ટર",
      morningsLabel: "આરામ અને કલ્યાણ",
      morningsText:
        "સુંદર આરામદાયક ઓરડાઓ, વિશાળ સામૂહિક ભોજનગૃહ, અમારી સ્વ-સંચાલિત વૃંદાવન ગીર ગૌશાળાનું પોષક દૂધ અને હેર સેલૂન.",
      afternoonsLabel: "સ્વાસ્થ્ય અને પુનર્વસન",
      afternoonsText:
        "ભગવાન મહાવીર મેડિકલ સેન્ટર, 24 કલાક MBBS ડૉક્ટર્સ, ફિઝિયોથેરાપી અને ગુજરાતના પ્રથમ વૃદ્ધાશ્રમ પક્ષઘાત પુનર્વસન કેન્દ્ર.",
      eveningsLabel: "આધ્યાત્મિકતા અને મનોરંજન",
      eveningsText:
        "દાદા ભગવાન જિન મંદિર, વાસુપૂજ્ય સ્વામી જૈન મંદિર, સ્વાધ્યાય હોલ, લાઇબ્રેરી, હોમ થિયેટર અને વિશેષ મનોરંજન કક્ષો.",
    },
    trustee: {
      quote:
        "\"જો તમે ક્યારેય વિચાર્યું હોય કે દયાનું એક કૃત્ય જીવન બદલી શકે કે નહીં — તો કોઈ રવિવારે અમારી મુલાકાત લો. તમે જવાબ સાથે પાછા ફરશો.\"",
      name: "શ્રીમતી સરસ્વતી જૈન",
      role: "ટ્રસ્ટી · વડીલ કલ્યાણ",
    },
    cta: {
      headingStart: "અમારા પરિવારનો ભાગ ",
      headingHighlight: "બનો.",
      description:
        "એક વડીલને પ્રાયોજિત કરો. એક ભોજન પ્રાયોજિત કરો. એક મેડિકલ દિવસ પ્રાયોજિત કરો. અથવા ફક્ત ચા માટે પધારો. સેવાનું દરેક સ્વરૂપ આવકાર્ય છે અને યાદ રખાય છે.",
      donateNow: "હમણાં દાન કરો",
      meetTrustees: "અમારા ટ્રસ્ટીઓને મળો",
      visitUs: "અમારી મુલાકાત લો",
    },
  },
  contact: {
    hero: {
      eyebrow: "સંપર્કમાં રહો",
      title: "અમારો સંપર્ક કરો",
      subtitle:
        "પ્રશ્નો, સ્વયંસેવા, ભાગીદારી — અમને તમારી પાસેથી સાંભળવું ગમશે.",
    },
    imageAlt: "Jivandhara ટ્રસ્ટ",
    info: {
      addressLabel: "સરનામું",
      addressValue: "પદ્માવતી નગર, ઇન્દિરા નગર વિભાગ-૨, લાંભા, અમદાવાદ – ૩૮૨૪૦૫",
      phoneLabel: "ફોન",
      phoneValue: "+91 9725521170, +91 8758413564, +91 9978015424",
      emailLabel: "ઇમેઇલ",
      emailValue: "jivandharavrudhashram@gmail.com",
      hoursLabel: "મુલાકાતના સમય",
      hoursValueMorning: "સવારે ૯ થી બપોરે ૧૨",
      hoursValueEvening: "બપોરે ૩ થી સાંજે ૭",
    },
    form: {
      heading: "અમને સંદેશ મોકલો",
      fullName: "પૂરું નામ",
      mobile: "મોબાઇલ",
      email: "ઇમેઇલ",
      subject: "વિષય",
      message: "સંદેશ",
      submit: "સંદેશ મોકલો",
      sending: "મોકલાઈ રહ્યું છે...",
    },
    toast: {
      success: "સંદેશ મોકલાયો. અમે ટૂંક સમયમાં તમારો સંપર્ક કરીશું.",
      error: "તમારો સંદેશ મોકલી શકાયો નહીં. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
  },
  donateHub: {
    hero: {
      liveDonations: "લાઈવ દાન",
      titleLine1: "તમારી કરુણાથી અમારા",
      titleLine2: "વડીલોનું જીવન ખીલે છે.",
      subtitle:
        "તમારા હૃદયને સ્પર્શતું કારણ પસંદ કરો — એક દિવસની ભોજન સેવાથી લઈને આખા ઓરડાના પ્રાયોજન સુધી. દરેક દાન માટે 80G રસીદ આપવામાં આવે છે.",
      browseCauses: "કારણો જુઓ",
      donateInKind: "વસ્તુ દાન કરો",
      totalRaised: "કુલ એકત્રિત દાન ભંડોળ",
      ofGoal: "{goal} ના લક્ષ્યાંકમાંથી",
      pctReached: "{pct}% પૂર્ણ",
      activeDrivesCount: "{count} સક્રિય દાન અભિયાન",
      activeDrivesLabel: "સક્રિય અભિયાન",
      taxEligibleLabel: "80G કરપાત્ર બચત",
    },
    filter: {
      all: "તમામ",
      inKind: "વસ્તુ દાન",
    },
    causes: {
      ongoingTitle: "ચાલુ દાન અભિયાનો",
      ongoingSubtitle:
        "લક્ષ્ય સુધી પહોંચવામાં મદદ કરો — તમારું દરેક દાન મહત્વપૂર્ણ છે.",
      browseCategorySubtitle: "આ શ્રેણીમાં દાન અભિયાનો જુઓ.",
      allCategorySubtitle: "{category} હેઠળના તમામ સક્રિય અભિયાનો.",
      noCampaignsFound: "આ શ્રેણીમાં હજુ સુધી કોઈ દાન અભિયાન મળ્યા નથી.",
      loadingCauses: "દાન અભિયાનો લોડ થઈ રહ્યા છે…",
      unableToLoad:
        "અભિયાનો લોડ કરી શકાયા નથી. કૃપા કરીને પછીથી પ્રયાસ કરો.",
    },
    inKindBanner: {
      title: "વસ્તુમાં દાન કરો",
      subtitle:
        "અનાજ, કપડાં, ધાબળા, દવાઓ, ફર્નિચર, તબીબી સાધનો — એક સરળ ફોર્મ ભરો અને અમારી ટીમ પિકઅપ માટે સંપર્ક કરશે.",
      cta: "વસ્તુ દાન ફોર્મ ભરો",
    },
    trust: {
      transparentTitle: "100% પારદર્શી",
      transparentBody:
        "દરેક દાનની નોંધ રાખવામાં આવે છે અને ડિજિટલ રસીદ આપવામાં આવે છે.",
      taxTitle: "80G કર લાભ",
      taxBody:
        "દાનની પુષ્ટિ થયાના 24 કલાકમાં સત્તાવાર 80G રસીદ આપવામાં આવે છે.",
      communityTitle: "વિશ્વસનીય સમુદાય",
      communityBody: "ટ્રસ્ટીઓ, સ્વયંસેવકો અને હજારો ઉદાર દાતાઓનો વિશ્વાસ.",
    },
    card: {
      fundedPct: "{pct}% ભંડોળ મળ્યું",
      stillNeeded: "{amount} ની હજુ જરૂર છે",
      ofTarget: "{target} માંથી",
      donateNow: "હમણાં દાન કરો",
    },
  },
  itemDonation: {
    hero: {
      eyebrow: "વસ્તુ દાન",
      title: "તમે કેવી રીતે દાન કરવા માંગો છો તે પસંદ કરો",
      subtitle: "જરૂરી વસ્તુઓ આપો અથવા ઉપયોગી ભંગાર વસ્તુઓ દાન કરો — બંને વડીલોની ઉત્તમ સંભાળ રાખવામાં મદદ કરે છે.",
    },
    inKindCard: {
      title: "ઇન-કાઇન્ડ (વસ્તુ) દાન",
      subtitle: "જરૂરી વસ્તુઓ આપો. ખુશીઓ વહેંચો.",
      description: "અનાજ, નવા સાધનો, કપડાં, ફર્નિચર અને અન્ય વસ્તુઓ દાન કરો. તમારી દયા દરરોજ વડીલોની વધુ સારી સંભાળ રાખવામાં મદદ કરે છે.",
      feature1: "દૈનિક જરૂરિયાતોને ટેકો આપો",
      feature2: "૧૦૦% સેવા માટે વપરાય છે",
      feature3: "સીધો સકારાત્મક પ્રભાવ પાડો",
      ctaLabel: "વસ્તુઓ દાન કરો",
      imageAlt: "અનાજ અને જરૂરી વસ્તુઓ સાથે દાન બોક્સ",
    },
    scrapCard: {
      title: "ભંગાર વસ્તુ દાન",
      subtitle: "તમારા માટે જૂનું, અમારા માટે ઉપયોગી.",
      description: "તમારું જૂનું ફર્નિચર, ફ્રીજ, ઉપકરણો અને અન્ય ઉપયોગી વસ્તુઓ દાન કરો. અમે અઠવાડિયામાં બે વાર અમદાવાદમાં તમારા સ્થાનેથી પિકઅપ કરીશું.",
      feature1: "મફત પિકઅપ સેવા",
      feature2: "પુનઃઉપયોગ અને કચરો ઘટાડો",
      feature3: "ઉમદા કાર્યને ટેકો આપો",
      ctaLabel: "ભંગાર વસ્તુઓ દાન કરો",
      imageAlt: "ભંગાર દાન માટે ફર્નિચર અને ઉપકરણો",
    },
    footerNotice: "નાનું કે મોટું દરેક દાન અમારા વડીલો માટે આરામ, સંભાળ અને સ્મિત લાવે છે.",
  },
  inkindDonation: {
    hero: {
      eyebrow: "ઇન-કાઇન્ડ (વસ્તુ) દાન",
      title: "વસ્તુ દાન ફોર્મ",
      subtitle: "અનાજ, કપડાં, ધાબળા, દવાઓ, ફર્નિચર અથવા કોઈપણ ઉપયોગી વસ્તુઓ દાન કરો. ફોર્મ ભરો અને અમારી ટીમ પિકઅપ અથવા ડ્રોપ-ઓફ વ્યવસ્થા કરશે.",
    },
    backLink: "દાનના પ્રકારો પર પાછા જાઓ",
    successTitle: "વસ્તુ દાન બદલ તમારો આભાર!",
    successDesc: "અમારી ટીમ વસ્તુ દાન મેળવવા/પિકઅપ ગોઠવવા માટે ૨૪ કલાકની અંદર તમારો સંપર્ક કરશે.",
    successDetails: "દાનની વિગતો",
    donorName: "દાતાનું નામ",
    mobileNumber: "મોબાઇલ નંબર",
    itemCategory: "વસ્તુ શ્રેણી",
    quantity: "જથ્થો",
    unit: "એકમ (યુનિટ)",
    itemName: "વસ્તુનું નામ",
    needPickup: "પિકઅપની જરૂર છે",
    pickupAddress: "પિકઅપ સરનામું",
    submitAnother: "અન્ય દાન સબમિટ કરો",
    browseCauses: "અન્ય સેવાઓ જુઓ",
    sections: {
      yourDetails: "તમારી વિગતો",
      whatToDonate: "તમે શું દાન કરવા માંગો છો",
      pickupDetails: "પિકઅપ વિગતો",
    },
    labels: {
      fullName: "પૂરું નામ",
      mobile: "મોબાઇલ",
      email: "ઈમેઇલ",
      category: "વસ્તુ શ્રેણી",
      selectCategory: "શ્રેણી પસંદ કરો",
      quantity: "જથ્થો",
      quantityPlaceholder: "દા.ત. ૨",
      unit: "એકમ (યુનિટ)",
      selectUnit: "એકમ પસંદ કરો",
      unitQty: "એકમ દીઠ જથ્થો / કુલ વજન",
      itemName: "વસ્તુનું નામ / વર્ણન",
      itemNamePlaceholder: "ચોખા, શિયાળુ ધાબળા, વ્હીલચેર…",
      preferredDate: "પસંદગીની દાન તારીખ",
      needPickupToggle: "પિકઅપની જરૂર છે?",
      needPickupHelp: "પિકઅપ સરનામાની વિગતો શેર કરવા માટે ચાલુ કરો",
      pickupAddress: "પિકઅપ સરનામું",
      pickupAddressPlaceholder: "મકાન / ફ્લેટ નં., શેરી, સોસાયટીનું નામ",
      area: "વિસ્તાર",
      areaPlaceholder: "મણિનગર",
      landmark: "લેન્ડમાર્ક",
      landmarkPlaceholder: "બસ સ્ટેન્ડ પાસે",
      pincode: "પિનકોડ",
      pincodePlaceholder: "૩૮૦૦૦૮",
      message: "સંદેશ / નોંધ",
      messagePlaceholder: "નવી સ્થિતિ, પિકઅપ સમય વગેરે.",
      submit: "વસ્તુ દાન સબમિટ કરો",
      submitting: "સબમિટ થઈ રહ્યું છે…",
    },
  },
  scrapDonation: {
    hero: {
      eyebrow: "ભંગાર વસ્તુ દાન",
      title: "ભંગાર દાન ફોર્મ",
      subtitle: "જૂનું ફર્નિચર, ઉપકરણો અને અન્ય ઉપયોગી વસ્તુઓ દાન કરો. અમે અમદાવાદમાં અઠવાડિયામાં બે વાર મફત પિકઅપ આપીએ છીએ.",
    },
    backLink: "દાનના પ્રકારો પર પાછા જાઓ",
    successTitle: "ભંગાર વસ્તુ દાન બદલ તમારો આભાર!",
    successDesc: "અમારી ટીમ અમદાવાદમાં તમારા ભંગાર સામાન માટે મફત પિકઅપ શેડ્યૂલ કરવા તમારો સંપર્ક કરશે.",
    successDetails: "દાનની વિગતો",
    donorName: "દાતાનું નામ",
    mobileNumber: "મોબાઇલ નંબર",
    itemCategory: "વસ્તુ શ્રેણી",
    quantity: "જથ્થો",
    itemName: "વસ્તુનું નામ",
    pickupAddress: "પિકઅપ સરનામું",
    submitAnother: "અન્ય દાન સબમિટ કરો",
    browseCauses: "અન્ય સેવાઓ જુઓ",
    sections: {
      yourDetails: "તમારી વિગતો",
      whatToDonate: "તમે શું દાન કરવા માંગો છો",
      pickupDetails: "પિકઅપ વિગતો",
      itemPhoto: "વસ્તુનો ફોટો",
    },
    labels: {
      fullName: "પૂરું નામ",
      mobile: "મોબાઇલ",
      email: "ઈમેઇલ",
      category: "વસ્તુ શ્રેણી",
      selectCategory: "શ્રેણી પસંદ કરો",
      quantity: "જથ્થો",
      quantityPlaceholder: "દા.ત. ૧",
      itemName: "વસ્તુનું નામ / વર્ણન",
      itemNamePlaceholder: "જૂનું ફ્રિજ, લાકડાની ખુરશી, વોશિંગ મશીન…",
      pickupAddress: "પિકઅપ સરનામું",
      pickupAddressPlaceholder: "મકાન / ફ્લેટ નં., શેરી, સોસાયટીનું નામ",
      area: "વિસ્તાર",
      areaPlaceholder: "મણિનગર",
      landmark: "લેન્ડમાર્ક",
      landmarkPlaceholder: "બસ સ્ટેન્ડ પાસે",
      pincode: "પિનકોડ",
      pincodePlaceholder: "૩૮૦૦૦૮",
      photoHelp: "પિકઅપનું આયોજન કરવામાં મદદ માટે વસ્તુનો ફોટો અપલોડ કરો (મરજિયાત, મહત્તમ ૫ MB).",
      uploadPhoto: "ફોટો અપલોડ કરો",
      changePhoto: "ફોટો બદલો",
      removePhoto: "દૂર કરો",
      message: "સંદેશ / નોંધ",
      messagePlaceholder: "પસંદગીનો પિકઅપ સમય, ગેટ એન્ટ્રી સૂચનાઓ…",
      submit: "ભંગાર દાન સબમિટ કરો",
      submitting: "સબમિટ થઈ રહ્યું છે…",
    },
  },
};

export default pages;
